export default {"src":"/_next/static/media/ZTS.501951d6.svg","height":18,"width":18};